import React from "react";
import SingleSelector from "@/components/SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const TemplateTypeList = React.forwardRef(
  (
    { disabled, name, value, onChange, clearable, data = [], className, style },
    ref
  ) => {
    const { t } = useTranslation();

    return (
      <SingleSelector
        placeholder={t({ defaultMessage: "操作类型" })}
        options={data.map(item => ({ id: item.eventId, name: item.eventName }))}
        clearable={clearable}
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
        className={className}
        style={{ width: 180, ...style }}
      />
    );
  }
);

export default TemplateTypeList;
